import type { IdentityVouchState, IdentityVouchView } from '@/api/identityVouch';

/**
 * Pure rules of the «Подтверждение семьи» card (docs/cabinet-redesign/04 §0.2 З-7): which state line and chip tone it
 * shows, and what the member's own answer reads. The card only renders what these return.
 */

export type ChipTone = 'pending' | 'done' | 'blocked' | 'neutral';

/**
 * The state line: while the request still waits, a member who already confirmed reads «Вы подтвердили · ждём
 * остальных»; otherwise the request's own state.
 */
export function vouchStateKey(v: Pick<IdentityVouchView, 'state' | 'answer'>): string {
  if (v.state === 'PENDING' && v.answer === 'CONFIRMED') return 'cabinet.vouch.state.CONFIRMED_WAITING';
  return `cabinet.vouch.state.${v.state}`;
}

const TONE: Record<IdentityVouchState, ChipTone> = {
  PENDING: 'pending',
  PASSED: 'done',
  FAILED: 'blocked',
  EXPIRED: 'neutral',
  CANCELLED: 'neutral',
};

export function vouchTone(state: IdentityVouchState): ChipTone {
  return TONE[state] ?? 'neutral';
}

/** What the member answered, or null while they have not. */
export function myAnswerKey(v: Pick<IdentityVouchView, 'answer'>): string | null {
  return v.answer ? `cabinet.vouch.answered.${v.answer}` : null;
}

/** A closed card is shown muted: nothing left to do on it. */
export function vouchClosed(v: Pick<IdentityVouchView, 'state' | 'canAnswer'>): boolean {
  return !v.canAnswer && v.state !== 'PENDING';
}
